<template>
  <section class="dashboard-container flex flex-wrap flex-col">
    <SmartRow>
      <SmartTitle class="form-list__title lg:col-12 mb-2 mt-2" weight="medium" heading="1">
        Relatórios
      </SmartTitle>
    </SmartRow>
    <SmartRow>
      <SmartButtonDash
        v-for="service in items"
        :key="service.title"
        :id="`${service.name}`"
        v-bind="service"
        @click.native="changeRoute(service.name)"
        :action="service.action"
        class="lg:col-4 md:col-12 sm:col-12 flex flex-wrap"
      />
    </SmartRow>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'IconListReport',
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      webPermission: 'auth/webPermission'
    }),
    items() {
      return [
        {
          title: 'Relatório de KM',
          description: 'Relação de rotas detalhadas.',
          icon: 'data-report',
          buttonText: 'Mais detalhes',
          iconColor: '#66BB6A',
          permission: 'web.km.enderecos',
          name: 'KmReport'
        }
      ];
    }
  },
  methods: {
    changeRoute(routerName) {
      console.log(routerName);
      this.$router.push({ name: routerName });
    }
  }
};
</script>
